module.exports = __webpack_public_path__ + "static/img/map.e10d351.png";


//////////////////
// WEBPACK FOOTER
// ./static/v2/order/map.png
// module id = 41w/
// module chunks = 1